import qs from 'qs';
import makeError from 'make-error';
import request, { checkStatus } from '../../request';
import {
  PLAYER_CLIENT_TYPE_M3U8_ENCRYPTED,
  PLAYER_CLIENT_TYPE_M3U8_UNENCRYPTED,
  PLAYER_CLIENT_TYPE_MP3_ENCRYPTED,
  PLAYER_CLIENT_TYPE_MP3_UNENCRYPTED,
} from '../../../constants';

let API_BASE;
if (__CLIENT__ && typeof window !== 'undefined') {
  API_BASE = window.__api_base__;
} else {
  API_BASE = process.env.API_BASE;
}

export const TrackUrlResolveError = makeError('TrackUrlResolveError');

export async function mp3Resolver({
  id,
  quality,
  accessToken,
  clientVersion,
  deviceId,
  sonosIsConnected,
  useMP3EncryptedPlayer,
}) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Client': __ELECTRON__ ? 'desktop' : 'web',
    'X-Client-Version': clientVersion,
    'X-Device-ID': deviceId,
    'X-Device-Class': 'computer',
  };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  let clientType = useMP3EncryptedPlayer
    ? PLAYER_CLIENT_TYPE_MP3_ENCRYPTED
    : PLAYER_CLIENT_TYPE_MP3_UNENCRYPTED;

  if (sonosIsConnected) {
    clientType = 'sonos-2';
  }

  const requestObject = {
    method: 'GET',
    url: `${API_BASE}/v1.8/content/track/${id}`,
    query: {
      quality,
      format: 2,
      client_type: clientType,
      client_version: clientVersion,
      device_id: 'web',
    },
    headers,
  };
  const res = await request(requestObject);

  const checkedRes = checkStatus(res);
  const json = await checkedRes.json();
  if (!json.url) {
    throw new TrackUrlResolveError('Track URL was resolved as empty');
  }

  return json.url;
}

export function m3u8Resolver({
  id,
  quality,
  accessToken,
  clientVersion,
  deviceId,
  useM3U8EncryptedPlayer,
}) {
  const url = `${API_BASE}/v1.8/track/${id}.m3u8`;
  const query = {
    quality,
    client_version: clientVersion,
    client_type: useM3U8EncryptedPlayer
      ? PLAYER_CLIENT_TYPE_M3U8_ENCRYPTED
      : PLAYER_CLIENT_TYPE_M3U8_UNENCRYPTED,
    device_id: 'web',

    /*
      These params overwrite the corresponding x-
      headers in the gateway. Reason is that we can't
      set the headers here since the hls lib sends the request
    */
    h_client: 'web',
    h_client_version: clientVersion,
    h_device_id: deviceId,
    h_device_class: 'computer',
  };

  if (accessToken) {
    query.access_token = accessToken;
  }

  return url + '?' + qs.stringify(query);
}
